import React, { ReactNode, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Layout, Menu, MenuProps } from 'antd';
import { Link } from 'react-router';
import logo from '../assets/logo.png';
import { useAuth0 } from '@auth0/auth0-react';
import { usePersistedState } from '@relyant/ui';
import { getNavBarItems } from '../feature_config';
import { RelyantHeader } from './Header';
import { iconsMapping } from 'icons/iconMapping';
import { isAdmin } from '../constants';
import { useOrganization } from '@relyant/ui';

const { Sider } = Layout;

const NavBar = ({ withSideBar = true, children }: { withSideBar: boolean; children: ReactNode }) => {
  const navigate = useNavigate();
  const { organization } = useOrganization();

  const getSidebarItems = () => {
    const items = [];

    for (let item of getNavBarItems(organization)) {
      const icon = iconsMapping[item.icon];
      items.push({
        ...item,
        icon,
      });
    }
    return items;
  };

  const sidebarItems = getSidebarItems();

  const dropdDownItems: MenuProps['items'] = [
    {
      key: '1',
      label: 'Profile',
      style: { fontSize: 16 },
      onClick: () => {
        navigate('/profile');
      },
    },
    {
      key: '2',
      label: 'Logout',
      onClick: () => {
        sessionStorage.clear();
        logoutWithRedirect();
      },
      style: { fontSize: 16 },
    },
  ];
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = usePersistedState<boolean>('isNavBarCollapsed', false);

  const [current, setCurrent] = useState<string>(
    location.pathname === '/'
      ? sidebarItems[0].key
      : sidebarItems.filter((item) => `/${item.link}` === location.pathname).map((item) => item.key)[0]
  );
  const mode = 'vertical';
  const className = '';

  const { user, isAuthenticated, logout } = useAuth0();
  const logoutWithRedirect = () =>
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });

  // TODO: check the Admin role
  if (user && isAdmin(user)) {
    sidebarItems.push({
      key: '100',
      icon: null,
      link: 'admin',
      text: 'Admin',
    });
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {withSideBar && (
        <Sider theme="light" trigger={null} collapsible collapsed={isCollapsed}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              paddingLeft: 6,
              paddingBottom: 24,
            }}
          >
            {isCollapsed ? (
              <div style={{ padding: 12 }}>
                <Link to="/">
                  <img width={'100%'} src={logo} alt="Logo" />
                </Link>
              </div>
            ) : (
              <div style={{ padding: 12 }}>
                <Link to="/">
                  <img width={'80%'} src={logo} alt="Logo" />
                </Link>
              </div>
            )}
          </div>
          <Menu
            title={'Relyant'}
            theme="light"
            mode={mode}
            className={`${className} ant-menu-dropdown-${mode}`}
            defaultSelectedKeys={[]}
            selectedKeys={[current]}
          >
            {sidebarItems.map((item) => {
              return (
                <Menu.Item key={item.key} icon={item.icon} onClick={() => setCurrent(item.key)}>
                  <Link to={item.link}>{item.text}</Link>
                </Menu.Item>
              );
            })}
          </Menu>
        </Sider>
      )}
      <Layout>
        <RelyantHeader
          isAuthenticated={isAuthenticated}
          user={user}
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          dropdDownItems={dropdDownItems}
          withLogo={!withSideBar}
        />
        {children}
      </Layout>
    </Layout>
  );
};

export default NavBar;
